/* eslint-disable @typescript-eslint/no-var-requires */
const get = require("lodash.get");
const merge = require("deepmerge");
const DEVELOPMENT_KEY = "development";

const buildConfig = () => {
  const environment = process.env.CO_ENV || DEVELOPMENT_KEY;

  const defaultConfig = require(`./default.json`);
  const environmentConfig = require(`./${environment}.json`);

  return merge(defaultConfig, environmentConfig);
};
/* eslint-enable */

const config = buildConfig();
const getConfig = path => get(config, path);

export { config as default, buildConfig, getConfig };
